import { useMemo } from 'react';
import { GlobalMediaStore, useGlobalMediaStore } from './GlobalMediaProvider';
import { useMediaPlayerStore } from './MediaPlayerProvider';
import VideoJsPlayer from 'video.js';

export function useCanControl() {
  const player = useMediaPlayerStore(s => s.player);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const thisPlayer = player() as VideoJsPlayer;
  const globalMedia = useGlobalMediaStore() as GlobalMediaStore;

  return useMemo(
    () => !globalMedia.player || globalMedia.player === thisPlayer,
    [globalMedia, thisPlayer]
  );
}
